import * as Constants from 'const';
import { toPx } from 'utils/toPx';

const DEFAULT_FONT_SIZE = Constants.DefaultCustomStyle.FONT_SIZE as number;

export const calcFontSize = (fontSize = DEFAULT_FONT_SIZE): string => {
  return toPx(fontSize);
};

export interface BlockNode {
  setLineHeight(lineHeight: number | undefined): this;
  getLineHeight(): number | undefined;
  setFontSize(fontSize: number | undefined): this;
  getFontSize(): number | undefined;
  updateFontSize(fontSize: number | undefined): this;
}
